import * as Lexxy from "@37signals/lexxy"

// Attachments are disabled by default across rich text editors: visitor pass
// instructions are injected into emails, where embedded ActiveStorage images
// would not resolve reliably. Editors that need images opt in with
// preset="with_images" (or attachments="true" for unrestricted attachments).
Lexxy.configure({
  default: {
    attachments: false
  },
  with_images: {
    attachments: true,
    permittedAttachmentTypes: ["image/jpeg", "image/png"],
    toolbar: {
      upload: "image"
    }
  }
})

const MAX_ATTACHMENT_SIZE = 1024 * 1024 * 3

document.addEventListener("lexxy:file-accept", (event) => {
  if (event.detail.file.size > MAX_ATTACHMENT_SIZE) {
    event.preventDefault()
    alert("Only support attachment files upto size 3MB!")
  }
})
